import {eatalianoAxios} from "@/data/api/http/axios";
import {JobOpeningInOverview, UpdatedJobOpening} from "@/data/entities/jobOpening";

export const listJobOpenings = (restaurantId: number): Promise<JobOpeningInOverview[]> => (
    eatalianoAxios
        .get(`/careers/job-openings/${restaurantId}`)
        .then(response => response.data)
);

export const updateJobOpening = (jobOpeningId: number, updated: UpdatedJobOpening): Promise<JobOpeningInOverview> => (
    eatalianoAxios
        .patch(`/careers/job-openings/job/${jobOpeningId}`, updated)
        .then(response => response.data)
);
